import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { UnespCoreAccessDeniedComponent, UnespCoreAuthGuardService, UnespCorePageNotFoundComponent } from '@unesp/core'
import { HomeComponent } from './features/publico/home/home.component'
import { EmDesenvolvimentoComponent } from './shared/components/em-desenvolvimento/em-desenvolvimento.component'
import { environment } from 'src/environments/environment'

const routes: Routes = [
  // DEFAULT
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'auth',
    component: HomeComponent,
  },
  {
    path: 'page-not-found',
    component: UnespCorePageNotFoundComponent,
  },
  {
    path: 'access-denied',
    component: UnespCoreAccessDeniedComponent,
  },
  {
    path: 'redirect-legado',
    loadChildren: () =>
      import('./features/redirect/sispg-redirect-legado/redirect-legado.module').then(m => m.RedirectLegadoModule),
  },
  // PUBLICO
  {
    path: 'autenticidade-documento',
    loadChildren: () =>
      import('./features/publico/autenticidade-documento/autenticidade-documento.routes').then(
        m => m.DocumentoValidadorRoutes
      ),
  },
  {
    path: 'ajuda/suporte',
    loadComponent: () =>
      import('./features/publico/ajuda-suporte/ajuda-suporte.component').then(m => m.AjudaSuporteComponent),
    canActivate: [UnespCoreAuthGuardService],
    data: {
      allowedRoles: [
        `${environment.roles.AREX.name}`,
        `${environment.roles.CCD.name}`,
        `${environment.roles.CONSULTA_DISCENTE.name}`,
        `${environment.roles.DOCENTE.name}`,
        `${environment.roles.DTA.name}`,
        `${environment.roles.PROPG.name}`,
        `${environment.roles.STPG.name}`,
      ],
    },
  },
  {
    path: 'voltar-portal',
    loadComponent: () =>
      import('./features/publico/voltar-portal/voltar-portal.component').then(m => m.VoltarPortalComponent),
  },
  {
    path: 'em-desenvolvimento',
    component: EmDesenvolvimentoComponent,
  },
  {
    path: 'changelog',
    loadComponent: () => import('./features/publico/changelog/changelog.component').then(m => m.ChangeLogComponent),
  },
  // PROCESSO-SELETIVO
  {
    path: 'processo-seletivo/aluno-regular',
    loadChildren: () =>
      import('./features/publico/processo-seletivo/regular/processo-seletivo-regular.routes').then(
        m => m.ProcessoSeletivoRegularRoutes
      ),
  },
  {
    path: 'processo-seletivo/aluno-especial',
    loadChildren: () =>
      import('./features/publico/processo-seletivo/especial/processo-seletivo-especial.routes').then(
        m => m.ProcessoSeletivoEspecialRoutes
      ),
  },
  {
    path: 'login-candidato',
    loadComponent: () => import('./features/publico/login-candidato/login.component').then(m => m.LoginPageComponent),
  },
  {
    path: 'recuperar-senha-candidato',
    loadComponent: () =>
      import('./features/publico/login-candidato/recuperar-senha/recuperar-senha.component').then(
        m => m.RecuperarSenhaComponent
      ),
  },
  // CANDIDATO
  {
    path: 'candidato',
    loadChildren: () => import('./features/candidato/candidato.routes').then(m => m.CandidatoRoutes),
    canActivate: [UnespCoreAuthGuardService],
    data: { allowedRoles: [`${environment.roles.CANDIDATO.name}`] },
  },
  // DISCENTE
  {
    path: 'discente',
    loadChildren: () => import('./features/discente/discente.routes').then(m => m.DiscenteRoutes),
    canActivate: [UnespCoreAuthGuardService],
    data: { allowedRoles: [`${environment.roles.ALUNO_REGULAR.name}`, `${environment.roles.ALUNO_ESPECIAL.name}`] },
  },
  // PROPG
  {
    path: 'propg',
    loadChildren: () => import('./features/propg/prog.routes').then(m => m.PropgRoutes),
    canActivate: [UnespCoreAuthGuardService],
    data: { allowedRoles: [`${environment.roles.PROPG.name}`] },
  },
  // STPG
  {
    path: 'stpg',
    loadChildren: () => import('./features/stpg/stpg.routes').then(m => m.StpgRoutes),
    canActivate: [UnespCoreAuthGuardService],
    data: { allowedRoles: [`${environment.roles.STPG.name}`] },
  },
  // DEFAULT
  {
    path: '**',
    redirectTo: '/page-not-found',
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
